



























import { PropType } from 'vue';
import { defineComponent, toRefs } from '@vue/composition-api';
import { AdgroupFormData } from '@tt4b/ttam-enums';
import { useOfflineTags } from '../hooks/use-offline-tags';
export default defineComponent({
  name: 'OfflineTags',
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const { adgroupData } = toRefs(props);
    const { dialogConfig, handleHashtagOffline, handleInterestKeywordsOffline } = useOfflineTags({
      adgroupData,
    });
    const change = data => {
      ctx.emit('change', data);
    };
    const handleHashtagOfflineAction = list => {
      handleHashtagOffline(list, change);
    };
    const handleInterestKeywordsOfflineAction = list => {
      handleInterestKeywordsOffline(list, change);
    };
    return {
      dialogConfig,
      handleHashtagOffline: handleHashtagOfflineAction,
      handleInterestKeywordsOffline: handleInterestKeywordsOfflineAction,
    };
  },
});
